import { type FC } from "react";
import { Checkbox, type CheckboxProps, Icon } from "semantic-ui-react";
import { Tooltip } from "components/common/tooltip";
import { type FormikProps } from "formik";

import styles from "./licensingSettings.module.scss";
import { type PackSettingsView } from "../../../types/state";
import { PricingTypes } from "enums/licensing/pricingTypes";
import { Typography } from "components/common/Typography/Typography";

interface LicensingSettingsProps extends FormikProps<PackSettingsView> {
  disabled: boolean;
  propertyNamePrefix: string;
  save: () => void;
}

export const LicensingSettings: FC<LicensingSettingsProps> = ({
  values,
  propertyNamePrefix,
  disabled,
  save,
  ...rest
}) => {
  const licensingSettings = values.licensingSettings;

  const handleChange = (field: string) => async (_: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
    await rest.setFieldValue(`${propertyNamePrefix}.${field}`, data.checked);
    save();
  };

  return (
    <>
      <Typography variant="title2" bold>
        LICENSING
      </Typography>
      {values.pricingTypeId === PricingTypes.Other && (
        <div className={styles.root}>
          <Checkbox
            label="No Expiration"
            checked={licensingSettings.noExpiration}
            onChange={handleChange("noExpiration")}
            disabled={disabled || rest.isSubmitting}
            toggle
          />
          <Tooltip
            className={styles.tooltip}
            target={<Icon className="info circle" />}
            content="Enable this option to remove the need for setting an expiration date when the pack is enabled for a customer. Recommended for free packs to avoid manual extensions."
            styles={{ width: "20rem" }}
            hideOnScroll
            showAlways
          />
        </div>
      )}
      <div className={styles.root}>
        <Checkbox
          label="Unlimited Licenses"
          checked={licensingSettings.unlimitedLicenses}
          onChange={handleChange("unlimitedLicenses")}
          disabled={disabled || rest.isSubmitting}
          toggle
        />
        <Tooltip
          className={styles.tooltip}
          target={<Icon className="info circle" />}
          content="Enable this option to automatically adjust license quantities based on usage when this pack is enabled for a customer. Recommended for free packs to avoid manual license increases."
          styles={{ width: "20rem" }}
          hideOnScroll
          showAlways
        />
      </div>
    </>
  );
};
